export default {
      id: "contact-usage",
      viewBox: "0 0 60 60",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#contact-usage",
      toString: function () {
        return this.url;
      }
    }